export default {
  gradesLoading: false,
  grades: []
}
